import instance from "lib/axiosInterceptor";
import {
  AddMultipleDocumentsToPresentationPayload,
  AddMultipleDocumentsToPresentationResponse,
  AddDocumentToPresentationPayload,
  AddDocumentToPresentationResponse,
  DeletePresentationDocumentPayload,
  DeletePresentationDocumentResponse,
  GetAllPresentationsPayload,
  GetAllPresentationsResponse,
  CreatePresentationPayload,
  CreatePresentationResponse,
  DeletePresentationPayload,
  DeletePresentationResponse,
  UpdatePresentationPositionPayload,
  UpdatePresentationPositionResponse,
  AddGuestsToPresentationPayload,
  AddGuestsToPresentationResponse,
  GetPresentationGuestsResponse,
  RemoveGuestsFromPresentationPayload,
  RemoveGuestsFromPresentationResponse,
  GetPresentationDetailsPayload,
  GetPresentationDetailsResponse,
  RemoveDocumentFromPlaylistPayload,
  RemoveDocumentFromPlaylistResponse,
  EditPresentationPayload,
  EditPresentationResponse,
} from "interfaces";

export async function addMultipleDocumentsToPresentationService(
  payload: AddMultipleDocumentsToPresentationPayload
): Promise<AddMultipleDocumentsToPresentationResponse> {
  const response =
    await instance.post<AddMultipleDocumentsToPresentationResponse>(
      `/Presentation/AddDocument/Multiple`,
      payload
    );
  return response.data;
}

export async function addDocumentToPresentationService(
  payload: AddDocumentToPresentationPayload
): Promise<AddDocumentToPresentationResponse> {
  const { formData, config } = payload;

  let response;
  if (config) {
    response = await instance.post(`/Presentation/AddDocument`, formData, {
      ...config,
      headers: {
        "Content-Type": "multipart/form-data",
        ...(config.headers || {}),
      },
    });
  } else {
    response = await instance.post(`/Presentation/AddDocument`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  return response.data;
}

export async function deletePresentationDocumentService(
  payload: DeletePresentationDocumentPayload
): Promise<DeletePresentationDocumentResponse> {
  const response = await instance.delete<DeletePresentationDocumentResponse>(
    `/Presentation/Document/${payload.selectedDocument}`,
    {
      params: { archive: payload.isArchive },
    }
  );
  return response.data;
}

export async function getAllPresentationsService(
  params_: GetAllPresentationsPayload
): Promise<GetAllPresentationsResponse> {
  const params: GetAllPresentationsPayload = {
    ...params_,
  };

  // Remove undefined values
  Object.keys(params).forEach((key) => {
    if (params[key as keyof GetAllPresentationsPayload] === undefined) {
      delete params[key as keyof GetAllPresentationsPayload];
    }
  });

  const response = await instance.get<GetAllPresentationsResponse>(
    `/presentation/all`,
    { params }
  );
  return response.data;
}

export async function createPresentationService(
  payload: CreatePresentationPayload
): Promise<CreatePresentationResponse> {
  const response = await instance.post<CreatePresentationResponse>(
    "/presentation/new",
    payload
  );
  return response.data;
}

export async function deletePresentationService(
  payload: DeletePresentationPayload
): Promise<DeletePresentationResponse> {
  const response = await instance.post<DeletePresentationResponse>(
    `/Presentation/delete/${payload.presentationId}`
  );
  return response.data;
}

export async function updatePresentationPositionService(
  payload: UpdatePresentationPositionPayload
): Promise<UpdatePresentationPositionResponse> {
  const response = await instance.post<UpdatePresentationPositionResponse>(
    `/Presentation/UpdatePosition/${payload.presentationId}`,
    payload.documents
  );
  return response.data;
}

export async function addGuestsToPresentationService(
  payload: AddGuestsToPresentationPayload
): Promise<AddGuestsToPresentationResponse> {
  const response = await instance.post<AddGuestsToPresentationResponse>(
    `/Presentation/AddGuests/${payload.presentationId}`,
    payload.guests
  );
  return response.data;
}

export async function getPresentationGuestsService(
  presentationId: string
): Promise<GetPresentationGuestsResponse> {
  const response = await instance.get<GetPresentationGuestsResponse>(
    `/Presentation/Guests/${presentationId}`
  );
  return response.data;
}

export async function removeGuestsFromPresentationService(
  payload: RemoveGuestsFromPresentationPayload
): Promise<RemoveGuestsFromPresentationResponse> {
  const response = await instance.post<RemoveGuestsFromPresentationResponse>(
    `/Presentation/RemoveGuests/${payload.presentationId}`,
    payload.guests
  );
  return response.data;
}

export async function getPresentationDetailsService(
  payload: GetPresentationDetailsPayload
): Promise<GetPresentationDetailsResponse> {
  const response = await instance.get<GetPresentationDetailsResponse>(
    `/presentation/${payload.presentationId}?presentaConnectionId=${
      payload.connectionId ?? ""
    }`
  );
  return response.data;
}

export async function removeDocumentFromPlaylistService(
  payload: RemoveDocumentFromPlaylistPayload
): Promise<RemoveDocumentFromPlaylistResponse> {
  const response = await instance.post<RemoveDocumentFromPlaylistResponse>(
    `/Presentation/RemoveDocument/${payload.presentationId}/${payload.documentId}`
  );
  return response.data;
}

export async function editPresentationService(
  payload: EditPresentationPayload
): Promise<EditPresentationResponse> {
  const response = await instance.post<EditPresentationResponse>(
    `/Presentation/Update/${payload.presentationId}`,
    payload.data
  );
  return response.data;
}
